/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Rail_Diet_BodyInputs */

const en_platform_rail_diet_body = /** @type {(inputs: Platform_Rail_Diet_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meals with calories and macros for every day, written once.`)
};

const pl_platform_rail_diet_body = /** @type {(inputs: Platform_Rail_Diet_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posiłki z kaloriami i makro na każdy dzień, ułożone raz.`)
};

/**
* | output |
* | --- |
* | "Meals with calories and macros for every day, written once." |
*
* @param {Platform_Rail_Diet_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_rail_diet_body = /** @type {((inputs?: Platform_Rail_Diet_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Rail_Diet_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_rail_diet_body(inputs)
	return en_platform_rail_diet_body(inputs)
});